"use client";

import styled from "styled-components";
import { sizes } from "./globalsStyles";

export const Main = styled.main<{ $backgroundUrl: string }>`
  background-color: #f8f8f6;
  background-image: url(${(p) => p.$backgroundUrl});
  height: calc(100% - ${sizes.navbarHeight}px);
  /* height: -webkit-fill-available; */
  overflow: auto;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  direction: rtl;
`;
